import { object } from 'superstruct';
import { email } from '@arc/shared/util-superstruct';
export const AddPasswordResetDto = object({
  email: email()
});